module.exports = __webpack_public_path__ + "static/media/setQuest.9524936d.png";